// Mirrors `ERROR_*` in `employee_skills/api_v3/team_builder_views.py`. The message on the wire is
// untranslatable English, so the code carries the meaning; these numbers must never be renumbered.
export const TB_ERROR_DUPLICATE_TITLE = 201;
export const TB_ERROR_EMPLOYEE_OUT_OF_SCOPE = 202;

// One code, one explanation, wherever the failure surfaces — the duplicate title is reported by
// both the create dialog and the rename bar.
const TB_ERROR_MESSAGES: Record<number, string> = {
  [TB_ERROR_DUPLICATE_TITLE]: 'hr.teambuilder.error.duplicate_title',
  [TB_ERROR_EMPLOYEE_OUT_OF_SCOPE]: 'hr.teambuilder.error.employee_out_of_scope'
};

// `fallback` stays right for every failure the server did not explain — a network drop, a 500,
// or a code this build does not know yet.
export const getTbErrorMessage = (fallback: string, errorCode?: number | null): string =>
  (errorCode && TB_ERROR_MESSAGES[errorCode]) || fallback;

// The two dead ends a team fetch can hit; `undefined` leaves `FetchFailedAlert` on its own
// retryable copy, which is right for a network drop and wrong for a refusal.
export const getTbFetchMessage = (notFound?: boolean, forbidden?: boolean): string | undefined =>
  (notFound && 'hr.teambuilder.team_not_found') || (forbidden && 'error.forbidden') || undefined;
